<osp-button
  [category]="'ghost'"
  [rounded]="true"
  (onClick)="onClick.emit()"
  [disabled]="$disabled()"
  [ospTooltip]="$tooltip() || ('modules.notification.acknowledge' | translate)"
  [tooltipPosition]="'left'"
>
  <osp-icon [icon]="IconKey.TopbarNotificationAcknowledge | icon" [iconSize]="'large'"></osp-icon>
</osp-button>
